import { useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Paper, Stack, Typography } from '@mui/material';

import { useTranslationHook } from '../../hooks/UseTranslationHook';

const VisitSubvisits = ({
  row: rowProp,
  subvisitData,
  visitColumns,
  actionColumn,
  isFiltering,
  setIsFiltering,
  setParentVisit,
}) => {
  const { noVisitsString } = useTranslationHook();

  const gridHeight = Math.min(200, 100 + subvisitData.length * 50);

  useEffect(() => {
    setIsFiltering(true);
    setParentVisit(rowProp.id);
    setIsFiltering(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowProp.id]);

  return (
    <Stack
      sx={{ py: 2, width: '100%', height: `${gridHeight} px` }}
      direction='column'
    >
      <Paper sx={{ flex: 1, width: '100%', p: 1, height: '100%' }}>
        <Stack direction='column' spacing={1} sx={{ height: '100%' }}>
          <Typography variant='h6'>{`#${rowProp.id} | ${rowProp.business_name} | ${rowProp.site_name}`}</Typography>
          <DataGridPro
            loading={isFiltering}
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'asc' }],
              },
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
              pinnedColumns: { right: ['action'] },
            }}
            density='compact'
            columns={visitColumns.concat(actionColumn)}
            rows={subvisitData}
            autoHeight
            slots={{
              noRowsOverlay: () => (
                <Stack
                  height='100%'
                  alignItems='center'
                  justifyContent='center'
                >
                  {noVisitsString}
                </Stack>
              ),
            }}
            hideFooter
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default VisitSubvisits;
